<template>
    <div v-if="millesime" class="d-flex flex-column my-5 container">
        <h3 class="col d-flex " v-if="terrCodeSelected && terrLabelSelected"> Territoire d'étude :
            <span v-if="multiCodes" class="text-primary ml-1"> {{ terrLabelTitleSelected }} ({{ multiCodes.toString()
            }})
            </span>
            <span v-else class="text-primary ml-1"> ({{ terrCode }})
                {{ terrLabel }}
            </span>
        </h3>

        <div class="col d-flex flex-column justify-content-between ">
            <h4 class="mb-5">Quelques données Synthétiques <span style="font-size:1rem;">
                    ( <span class="text-primary">{{ millesimeRef.title }}</span> )</span>
            </h4>
            <h5 class="font-weight-bold text-secondary">
                Territoire :
                <span v-if="terrLevelSelected === 'multi_dep'" class="text-primary">Département</span>
                <span v-else-if="terrLevel === 'multi_com' || terrLevel === 'epci' || terrLevel === 'ept'"
                    class="text-primary">Commune </span>
                <span v-else class="text-primary">{{ terrLabelSelected }}</span>
                ({{ terrCodeSelected }})
            </h5>
        </div>
        <Loading v-if="loading" />
        <div v-if="stats && Array.isArray(stats) && stats.length > 0" class="row no-gutters row-cols-1 row-cols-md-2 row-cols-lg-6">
            <div v-for="stat in stats" :key="stat.id" :class="`${stat.is_double ? 'col col-lg-4' : 'col'} p-1`">
                <PpomBlocStat :outlined="false" :double="stat.is_double" :stattype="stat.typeref" :title="stat.title"
                    :ref-indic="stat.ref" :src="stat.src" :color="stat.color" :val="stat.val.refData" />
            </div>
        </div>
        <div v-if="stats.length && stats.length > 0" class="row cols-6 h-4">
            <div class="col d-flex flex-column flex-md-row justify-content-between align-items-center mt-1 mb-5">
                <div class="d-flex align-items-center mb-3 sm:mb-0">
                    <div class="btn btn-sm btn-outline-primary bloc_stat-csv-btn mr-2" @click="dowloadDataAsCSVFile">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                            <path fill="currentColor"
                                d="M15 9H5V5h10m-3 14a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3a3 3 0 0 1-3 3m5-16H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-4-4Z" />
                        </svg>
                    </div>
                    <div class="text-sm">Télécharger ces données de synthèse</div>
                </div>
                <a href="/ppom_export/1" class="btn btn-primary">
                    <i class="fa fa-cloud-download text-white mr-1" aria-hidden="true"></i>
                    Télécharger l'intégralité des données pour votre territoire
                </a>
            </div>
            
            <div v-if="terrCode==999" class="row d-flex flex-row justify-content-center align-items-center mb-5 text-primary text-center" style="font-size: 0.85rem;line-height: 1.2rem;font-style: italic;"> 
            <div class="bg-primary p-1 px-2 pl-3 rounded-b-full" style=""><i class="fa fa-exclamation  text-white mr-1" aria-hidden="true"></i></div>
            Remarque : attention, les seuils d'estimations des taux de fragilité varient entre la métropole et les DROMs, ainsi les données France entière ne sont pas disponibles. Vous pouvez retrouver les données relatives aux départements d'outre-mer dans les territoires ci-dessous.  </div>
        </div>

        <div class="d-flex content-justify-start align-items-center">
            <h5 class="font-weight-bold text-secondary mt-4 col-4">
                Territoir de référence : <span class="text-primary">{{ terrNameRef }}</span>
            </h5>
            <select v-if="listTerrs" class="form-control font-weight-bold col-8 " v-model="selectedCodeTerr"
                @change="handleRefChange">
                <option value="">Selectionnez un territoire</option>
                <option v-for="(terr, index) in listTerrs" :key="index" :value="terr.code">{{ terr.nom }} ({{ terr.code
                }})
                </option>
            </select>
        </div>
        <Loading v-if="loading2" />
        <div v-else-if="stats2.length && stats2.length > 0"
            class="row no-gutters row-cols-1 row-cols-md-2 row-cols-lg-6">
            <div v-for="statVal in stats2" :key="statVal.id"
                :class="`${statVal.is_double ? 'col col-md-2 col-lg-4' : 'col'} p-1`">
                <PpomBlocStat :outlined="true" :double="statVal.is_double" :stattype="statVal.typeref"
                    :ref-indic="statVal.ref" :src="statVal.src" :title="statVal.title" :color="statVal.color"
                    :val="statVal.val.refData" />
            </div>
        </div>
        <div v-else class="d-flex flex-column my-5 container">
            <p>Désolé. Les données ne sont actuellement pas disponible pour ce territoire</p>
        </div>
    </div>

</template>

<script>
import PpomBlocStat from './PpomBlocStat.vue';
import Loading from '../Loading.vue';
import PpomService from '../../services/PpomService';
import CogApiService from '../../services/CogApiService';

const cogApiService = new CogApiService();

export default {
    name: "ppom_stats",
    //props: ['tag', 'dfperims', 'terrLevelSelected', 'terrCodeSelected', 'terrLabelSelected', 'millesime', 'section'],
    props: ['tag', 'dfperims', 'terrLevelSelected', 'terrCodeSelected', 'terrLabelSelected', 'millesime', 'section'],
    components: {
        PpomBlocStat,
        Loading
    },
    data: function () {
        return {
            loading: false,
            loading2: false,
            terrRef: [
                {
                    "code": '11',
                    "label": 'France',
                    "level": 'fra'
                }
            ],
            data: [],
            data2: [],
            stats: [],
            stats2: [],
            listTerrs: [],
            selectedCodeTerr: '',
            terrLevelRef: '',
            terrNameRef: '',
            millesimeRef: '',
            refsReference: [],
            refsVal: null,
            refsVal2: null,
            ppomService: null,
            userPerims: null,
            terrLabelTitleSelected: null,
            ept_coms: null,
            multiCodes: null,
            terrLevel: null,
            terrCode: null,
            terrLabel: null,
            purData: null
        }
    },
    mounted() {
        this.ppomService = new PpomService();
        this.millesimeRef = JSON.parse(this.millesime);

        this.userPerims = JSON.parse(this.dfperims);
        this.terrLabel = this.terrLabelSelected;
        this.terrCode = this.terrCodeSelected;
        this.terrLevel = this.terrLevelSelected;
        console.log("dfperims : ", this.userPerims, this.terrLevelSelected, this.terrCodeSelected, this.terrLabelSelected);

        this.buildDFPerims(this.userPerims.df_ano);

        console.log(localStorage.currentsection, this.section);
        if (localStorage.currentsection !== 'ppom' && this.section === 'ppom') {
            $("#convModal").modal('show');
            localStorage.currentsection = 'ppom';
        }
        this.ppomService.getRefs("synthetic").then(result => {

            this.refsReference = Array.from(JSON.parse(JSON.stringify(result)));
            this.refsVal = Array.from(JSON.parse(JSON.stringify(result)));
            this.refsVal2 = Array.from(JSON.parse(JSON.stringify(result)));
            this.buildUserLevel();
        })
    },
    methods: {
        persist() {
            localStorage.currentsection = this.section;
        },
        buildDFPerims: function (refPerims) {
            console.log("buildDFPerims")
            if (this.terrLevelSelected === "ept" && refPerims.comm && Array.isArray(refPerims.comm) && refPerims.comm.length > 0) {
                this.terrLevelSelected = "ept";
                //this.terrCodeSelected = refPerims.comm[0];
                this.terrLabelTitleSelected = "EPT ";
                this.ept_coms = refPerims.comm;
                return { "level": 'ept', "code": this.terrCodeSelected, "label": "EPCI" };
            }

            if (this.terrLevelSelected === "epci" && refPerims.comm && Array.isArray(refPerims.comm) && refPerims.comm.length > 0) {
                this.terrLevelSelected = "epci";
                this.terrLabelTitleSelected = "EPCI ";
                return { "level": 'epci', "code": this.terrCodeSelected, "label": "EPCI" };
            }


            if ("fr_entiere" in refPerims && refPerims.fr_entiere) {
                this.terrLevelSelected = "fra";
                this.terrCodeSelected = "fra";
                this.terrLabelTitleSelected = "";
                return { "level": 'fra', "code": 'fra', "label": "France Métropolitaine" };
            }
            if ("reg" in refPerims && Array.isArray(refPerims.reg) && refPerims.reg.length > 0) {
                this.terrLevelSelected = "reg";
                this.terrCodeSelected = refPerims.reg[0];
                this.terrLabelTitleSelected = "Région ";
                console.log("refPerims.reg", refPerims.reg);
                return { "level": 'reg', "code": refPerims.reg[0], "label": "Régions" };
            } else if ("dep" in refPerims && Array.isArray(refPerims.dep) && refPerims.dep.length > 0) {

                if (refPerims.dep.length > 1) {
                    this.terrLevelSelected = "multi_dep";
                    this.terrLabelTitleSelected = "Multi départemental "
                    this.multiCodes = refPerims.dep;
                    this.terrCodeSelected = refPerims.dep[1];
                } else {
                    this.terrLevelSelected = "dep";
                    this.terrLabelTitleSelected = "Département ";
                    this.terrCodeSelected = refPerims.dep[0];
                }

                return { "level": 'dep', "code": refPerims.dep[0], "label": "Département" };

            } else if ("comm" in refPerims && Array.isArray(refPerims.comm) && refPerims.comm.length > 0) {
                let coms = refPerims.comm;
                return {
                    "level": coms.length > 1 ? 'epci' : 'com',
                    "code": coms.length > 1 ? coms[1] : [],
                    "label": coms.length > 1 ? "Communes " : "Commune"
                };
            } else {
                console.log("Rien");
                return null;
            }
        },
        buildUserLevel: function () {
            console.log("buildUserLevel", this.terrLevelSelected);
            switch (this.terrLevelSelected) {
                case 'fra':
                    axios.get("https://geo.api.gouv.fr/regions?fields=nom,code")
                        .then((result) => {
                            console.log("regs", result.data);
                            let filteredReg = result.data.filter((reg) => reg.code !== "01" && reg.code !== '03' && reg.code !== '06');
                            this.listTerrs = filteredReg;
                        })
                    this.getData('11', 'reg', 2);
                    this.selectedCodeTerr = '11';
                    this.terrLevelRef = "reg";
                    this.terrNameRef = "Région";
                    this.terrLabelSelected = "France métropole";
                    this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    break;
                case 'reg':
                    this.terrCodeSelected = (this.terrCodeSelected.length === 1) ? '0' + this.terrCodeSelected : this.terrCodeSelected;
                    axios.get(`https://geo.api.gouv.fr/regions/${this.terrCodeSelected}/departements?fields=nom,code,region`)
                        .then((result) => {
                            console.log("reg result", result.data);
                            this.terrLabelSelected = result.data[0].region.nom;// nom de la région 
                            this.listTerrs = result.data;
                            this.selectedCodeTerr = result.data[0].code;
                            this.getData(result.data[0].code, 'dep', 2);
                        })

                    this.terrLevelRef = "dep";
                    this.terrNameRef = "Département";
                    this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    break;
                case 'dep':
                    this.terrCodeSelected = (this.terrCodeSelected.length === 1) ? '0' + this.terrCodeSelected : this.terrCodeSelected;
                    axios.get(`https://geo.api.gouv.fr/departements/${this.terrCodeSelected}?fields=codeRegion,region`)
                        .then((result) => {
                            console.log("api result : ", result.data);
                            this.listTerrs = [
                                {
                                    "code": result.data.region.code,
                                    "nom": result.data.region.nom
                                }
                            ];
                            this.selectedCodeTerr = result.data.region.code;
                            this.terrLabelSelected = result.data.nom;
                            this.getData(result.data.region.code, 'reg', 2);
                        })
                    this.terrLevelRef = "reg";
                    this.terrNameRef = "Région";
                    this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    break;
                case 'multi_dep':
                    this.terrCodeSelected = (this.terrCodeSelected.length === 1) ? '0' + this.terrCodeSelected : this.terrCodeSelected;
                    this.userPerims.df_ano.dep.forEach(element => {
                        axios.get(`https://geo.api.gouv.fr/departements/${element}?fields=nom,code`)
                            .then((result) => {
                                this.listTerrs = [
                                    ...this.listTerrs,
                                    {
                                        "code": result.data.code,
                                        "nom": result.data.nom
                                    }
                                ]
                            })
                            .finally(() => {
                                if (this.listTerrs.length === this.userPerims.dep_complet.length) {
                                    this.listTerrs = this.listTerrs.sort((a, b) => a.code > b.code ? 1 : -1);
                                    this.selectedCodeTerr = this.listTerrs[0].code;
                                    this.getData(this.selectedCodeTerr, 'dep', 2);
                                }
                            })
                    });
                    this.terrLevelRef = "dep";
                    this.terrNameRef = "Département";
                    this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    break;
                case 'epci':
                    axios.get(`https://geo.api.gouv.fr/epcis/${this.terrCodeSelected}/communes?fields=code,nom`)
                        .then((result) => {
                            console.log("epci", result.data);
                            this.listTerrs = result.data;
                            if (result.data.find(el => el.code === '13055')) {
                                console.log("epci 13055 trouvé!");
                                this.listTerrs = this.listTerrs.filter(el => el.code !== '13055');
                                let arrond = cogApiService.getArrondissments('13055');
                                this.listTerrs = [...this.listTerrs, ...arrond];
                                this.listTerrs.sort((a, b) => a.nom < b.nom ? -1 : 1);
                            }
                            if (result.data.find(el => el.code === '69123')) {
                                this.listTerrs = this.listTerrs.filter(el => el.code !== '69123');
                                let arrond = cogApiService.getArrondissments('69123');
                                this.listTerrs = [...this.listTerrs, ...arrond];
                                this.listTerrs.sort((a, b) => a.nom < b.nom ? -1 : 1);
                            }
                            if (result.data.find(el => el.code === '75056')) {
                                this.listTerrs = this.listTerrs.filter(el => el.code !== '75056');
                                let arrond = cogApiService.getArrondissments('75056');
                                this.listTerrs = [...this.listTerrs, ...arrond];
                                this.listTerrs.sort((a, b) => a.nom < b.nom ? -1 : 1);
                            }

                            this.selectedCodeTerr = this.listTerrs[1].code;
                            this.terrLabelSelected = this.listTerrs[0].nom;
                            this.terrCodeSelected = this.listTerrs[0].code;
                            this.getData(this.selectedCodeTerr, 'com', 2);
                        })
                    this.terrLevelRef = "com";
                    this.terrNameRef = "Communes";
                    this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    break;
                case 'ept':
                    this.listTerrs = [];
                    if (this.ept_coms && this.ept_coms.length > 0) {

                        this.ept_coms.forEach((com, index) => {
                            axios.get(`https://geo.api.gouv.fr/communes/${com}?fields=code,nom`)
                                .then((result) => {
                                    this.listTerrs = [...this.listTerrs,
                                    {
                                        "code": result.data.code,
                                        "nom": result.data.nom
                                    }
                                    ];

                                    if (index === this.ept_coms.length - 1) {
                                        //console.log("listTerrs", this.listTerrs);
                                        this.selectedCodeTerr = this.listTerrs[0].code;
                                        this.getData(this.selectedCodeTerr, 'com', 2);
                                    }
                                })

                        })
                        this.terrLevelRef = "com";
                        this.terrNameRef = "Communes";
                        this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    }
                    break;
                case 'com':
                    this.terrCodeSelected = (this.terrCodeSelected.length === 4) ? '0' + this.terrCodeSelected : this.terrCodeSelected;
                    axios.get(`https://geo.api.gouv.fr/communes/${this.terrCodeSelected}?fields=departement`)
                        .then((result) => {

                            this.listTerrs = [
                                {
                                    "code": result.data.departement.code,
                                    "nom": result.data.departement.nom
                                }
                            ];
                            this.selectedCodeTerr = result.data.departement.code;
                            this.terrLabelSelected = result.data.nom;
                            this.getData(result.data.departement.code, 'dep', 2);
                        })
                    this.terrLevelRef = "dep";
                    this.terrNameRef = "Département"
                    this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    break;
                default:
                    break;
            }
        },
        getData: function (inseeCode, terrLevel, order = 1) {
            order === 1 ? this.loading = true : null;
            order === 2 ? this.loading2 = true : null;
            let that = this;
            console.log("getData", inseeCode, terrLevel, order);
            axios.post('/api/ppom/stats', { "code": inseeCode, "level": terrLevel, "thema": "synthetic" }).then((result) => {
                // L'API retourne un tableau avec un seul élément, on prend le premier
                const dataValue = Array.isArray(result.data) ? result.data[0] : result.data;
                if (order === 1) {
                    this.purData = dataValue;
                    this.stats = that.ppomService.mergeData(dataValue, that.refsVal, order)
                } else {
                    this.stats2 = that.ppomService.mergeData(dataValue, that.refsVal2, order)
                }
                
            }).catch((error) => {
                console.log('PpomStats.vue getData error', error);
            }).finally(() => {
                order === 1 ? this.loading = false : null;
                order === 2 ? this.loading2 = false : null;
            });
        },
        dowloadDataAsCSVFile: function () {

            let text = "";
            for (const [key, value] of Object.entries(this.purData)) {
                console.log(key, value);
                text += `${key};${value}\n`;
            }
            let filename = 'ppom_tabl_cadrage_' + this.terrCodeSelected + '.csv';
            let element = document.createElement('a');
            element.setAttribute('href', 'data:application/csv;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', filename);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },
        handleRefChange: function () {
            this.stats2 = Array.from(JSON.parse(JSON.stringify(this.refsReference)));
            this.getData(this.selectedCodeTerr, this.terrLevelRef, 2 );
        }
    }
};
</script>

<style scoped>
.bloc_stat-csv-btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    border-radius: 3px;
    transition: background-color 0.15s ease-in-out;
}
</style>